var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-outline-light px-4 py-2 txt_ombre_333 txt_size_125",on:{"click":_vm.goBack}},[_c('span',{staticClass:"oi oi-chevron-left mr-2",staticStyle:{"font-size":"1rem"}}),_vm._v("\n    "+_vm._s(_vm.$t('question.goBack'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a30fec4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/ButtonGoBack.vue
// module id = 159
// module chunks = 0